const amountAndFee = document.querySelector("[data-payin-fee]");
const input = document.querySelector("#input-amount");

if (input && amountAndFee) {
  input.addEventListener("input", () => {
    amountWithFees = Number(input.value) + (Number(input.value) * Number(amountAndFee.dataset.payinFee) / 100)
    amountAndFee.textContent = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(amountWithFees)
  })
}
